/**
 * 动态表单和表格结构体转换工具类
 * ver 1.0.0
 */

let converterUtil = {}

// 单元格可渲染的组件
const _needRender = [
  'i-input',
  'input',
  'inputNumber',
  'panguInputNumber',
  'inputSelectOfModalTable',
  'panguSelect',
  'selectRemote',
  'readText',
  'readTextColorAndTitle',
  'readTextOfSideFrom',
  'referencePrice',
  'readTextNotUseVModel',
  'readTextTwo',
]
/**
 * 转换显示数据格式
 * @param {item} 后台定义结构体的元素
 */
converterUtil.formatConverterDetal = function (item, strategy) {
  if (!item.format) return
  if (!_needRender.some((im) => !item.component || im === item.component.code)) return
  if (!item.parameter) item.parameter = {}
  if (item.parameter.type) return
  //数字类型
  if (item.format.code == 'NUMBER') {
    if (!item.parameter.type) item.parameter.type = 'number'
    if (!item.parameter.format)
      item.parameter.format = strategy.POLICY_NUMBER_PRECISION
        ? parseInt(strategy.POLICY_NUMBER_PRECISION)
        : 6
  }
  //金额类型
  if (item.format.code == 'CURRENCY') {
    if (!item.parameter.type) item.parameter.type = 'currency'
    if (!item.parameter.format) item.parameter.format = 2
  }
  //单据类型
  if (item.format.code == 'PRICE') {
    if (!item.parameter.type) item.parameter.type = 'currency'
    if (!item.parameter.format)
      item.parameter.format = strategy.POLICY_PRICE_PRECISION
        ? parseInt(strategy.POLICY_PRICE_PRECISION)
        : 6
  }
  //百分比类型
  if (item.format.code == 'PERCENT') {
    if (!item.parameter.type) item.parameter.type = 'percent'
    if (!item.parameter.format) item.parameter.format = 0
  }
  //进度百分比类型-保留小数时直接截断
  if (item.format.code == 'PROGRESS') {
    if (!item.parameter.type) item.parameter.type = 'progress'
    if (!item.parameter.format) item.parameter.format = 0
  }
  //时间类型
  if (item.format.code == 'TIME') {
    if (!item.parameter.type) item.parameter.type = 'date'
    if (!item.parameter.format) item.parameter.format = 'HH:mm:ss'
  }
  //日期类型
  if (item.format.code == 'DATE') {
    if (!item.parameter.type) item.parameter.type = 'date'
    if (!item.parameter.format) item.parameter.format = 'YYYY-MM-DD'
  }
  //日期加时间类型
  if (item.format.code == 'DATETIME') {
    if (!item.parameter.type) item.parameter.type = 'date'
    if (!item.parameter.format) item.parameter.format = 'YYYY-MM-DD HH:mm:ss'
  }
}

export default converterUtil
